module.exports = __webpack_public_path__ + "static/media/room-3.dc6dc7ea.jpeg";